import { Extension } from "../../constants/extension";
import { AssetType } from "../../models/assets/asset";
import { Media } from "../../models/assets/media";
import {EntityType, mediaService} from "../../services/media-service";
import {BOOK_PATHS} from "./books/book-constants";

/*****************
 * DISCERNMENT OF SPIRITS COMPONENTS
 ****************/
export const DISCERNMENT_OF_SPIRITS_LOGO = {
    id: 1,
    name: BOOK_PATHS.DISCERNMENT_OF_SPIRITS,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.DISCERNMENT_OF_SPIRITS, AssetType.LOGO),
    type: AssetType.LOGO
};
export const DISCERNMENT_OF_SPIRITS_COVER = {
    id: 2,
    name: BOOK_PATHS.DISCERNMENT_OF_SPIRITS,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.DISCERNMENT_OF_SPIRITS, AssetType.COVER, Extension.JPG),
    type: AssetType.COVER
};
export const DISCERNMENT_OF_SPIRITS_PHOTOS = [
    {
        id: 2,
        name: BOOK_PATHS.DISCERNMENT_OF_SPIRITS,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.DISCERNMENT_OF_SPIRITS, AssetType.IMAGE, Extension.JPG, 1),
        type: AssetType.IMAGE
    },
    {
        id: 3,
        name: BOOK_PATHS.DISCERNMENT_OF_SPIRITS,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.DISCERNMENT_OF_SPIRITS, AssetType.IMAGE, Extension.JPG, 2),
        type: AssetType.IMAGE
    },
    {
        id: 4,
        name: BOOK_PATHS.DISCERNMENT_OF_SPIRITS,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.DISCERNMENT_OF_SPIRITS, AssetType.IMAGE, Extension.JPG, 3),
        type: AssetType.IMAGE
    },
];
export const DISCERNMENT_OF_SPIRITS_MEDIA_EN: Media = {
    logo: DISCERNMENT_OF_SPIRITS_LOGO,
    cover: DISCERNMENT_OF_SPIRITS_COVER,
    videos: [],
    photos: DISCERNMENT_OF_SPIRITS_PHOTOS,
    files: [],
};
export const DISCERNMENT_OF_SPIRITS_MEDIA_AR: Media = {
    logo: DISCERNMENT_OF_SPIRITS_LOGO,
    cover: DISCERNMENT_OF_SPIRITS_COVER,
    videos: [],
    photos: [
        {
            id: 1,
            name: BOOK_PATHS.DISCERNMENT_OF_SPIRITS,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.DISCERNMENT_OF_SPIRITS, AssetType.IMAGE, Extension.JPG, 1),
            type: AssetType.IMAGE
        },
        {
            id: 2,
            name: BOOK_PATHS.DISCERNMENT_OF_SPIRITS,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.DISCERNMENT_OF_SPIRITS, AssetType.IMAGE, Extension.JPG, 2),
            type: AssetType.IMAGE
        },
        {
            id: 3,
            name: BOOK_PATHS.DISCERNMENT_OF_SPIRITS,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.DISCERNMENT_OF_SPIRITS, AssetType.IMAGE, Extension.JPG, 3),
            type: AssetType.IMAGE
        },
    ],
    files: [],
};
/*****************
 * FACE TO FACE COMPONENTS
 ****************/
export const FACE_TO_FACE_LOGO = {
    id: 11,
    name: BOOK_PATHS.FACE_TO_FACE,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.FACE_TO_FACE, AssetType.LOGO),
    type: AssetType.LOGO
};
export const FACE_TO_FACE_COVER = {
    id: 12,
    name: BOOK_PATHS.FACE_TO_FACE,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.FACE_TO_FACE, AssetType.COVER, Extension.JPG),
    type: AssetType.COVER
};
export const FACE_TO_FACE_PHOTOS = [
    {
        id: 11,
        name: BOOK_PATHS.FACE_TO_FACE,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.FACE_TO_FACE, AssetType.IMAGE, Extension.JPG, 1),
        type: AssetType.IMAGE
    },
    {
        id: 12,
        name: BOOK_PATHS.FACE_TO_FACE,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.FACE_TO_FACE, AssetType.IMAGE, Extension.JPG, 2),
        type: AssetType.IMAGE
    },
    {
        id: 13,
        name: BOOK_PATHS.FACE_TO_FACE,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.FACE_TO_FACE, AssetType.IMAGE, Extension.JPG, 3),
        type: AssetType.IMAGE
    },
];
export const FACE_TO_FACE_MEDIA_EN: Media = {
    logo: FACE_TO_FACE_LOGO,
    cover: FACE_TO_FACE_COVER,
    videos: [],
    photos: FACE_TO_FACE_PHOTOS,
    files: [],
};
export const FACE_TO_FACE_MEDIA_AR: Media = {
    logo: FACE_TO_FACE_LOGO,
    cover: FACE_TO_FACE_COVER,
    videos: [],
    photos: [
        {
            id: 21,
            name: BOOK_PATHS.FACE_TO_FACE,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.FACE_TO_FACE, AssetType.IMAGE, Extension.JPG, 1),
            type: AssetType.IMAGE
        },
        {
            id: 22,
            name: BOOK_PATHS.FACE_TO_FACE,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.FACE_TO_FACE, AssetType.IMAGE, Extension.JPG, 2),
            type: AssetType.IMAGE
        },
        {
            id: 23,
            name: BOOK_PATHS.FACE_TO_FACE,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.FACE_TO_FACE, AssetType.IMAGE, Extension.JPG, 3),
            type: AssetType.IMAGE
        },
    ],
    files: [],
};
/*****************
 * LETTERS_OF_FIRE_MEDIA
 ****************/
const LETTERS_OF_FIRE_LOGO = {
    id: 31,
    name: BOOK_PATHS.LETTERS_OF_FIRE,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.LETTERS_OF_FIRE, AssetType.LOGO),
    type: AssetType.LOGO
};
const LETTERS_OF_FIRE_COVER = {
    id: 32,
    name: BOOK_PATHS.LETTERS_OF_FIRE,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.LETTERS_OF_FIRE, AssetType.COVER, Extension.JPG),
    type: AssetType.COVER
};
const LETTERS_OF_FIRE_PHOTOS = [
     {
            id: 31,
            name: BOOK_PATHS.LETTERS_OF_FIRE,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.LETTERS_OF_FIRE, AssetType.IMAGE, Extension.JPG, 1),
            type: AssetType.IMAGE
    },
    {
        id: 32,
        name: BOOK_PATHS.LETTERS_OF_FIRE,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.LETTERS_OF_FIRE, AssetType.IMAGE, Extension.JPG, 2),
        type: AssetType.IMAGE
    },
    {
        id: 33,
        name: BOOK_PATHS.LETTERS_OF_FIRE,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.LETTERS_OF_FIRE, AssetType.IMAGE, Extension.JPG, 3),
        type: AssetType.IMAGE
    },
];
export const LETTERS_OF_FIRE_MEDIA_EN: Media = {
    logo: LETTERS_OF_FIRE_LOGO,
    cover: LETTERS_OF_FIRE_COVER,
    videos: [],
    photos:LETTERS_OF_FIRE_PHOTOS,
    files: [],
};
export const LETTERS_OF_FIRE_MEDIA_AR: Media = {
    logo: LETTERS_OF_FIRE_LOGO,
    cover: LETTERS_OF_FIRE_COVER,
    videos: [],
    photos:LETTERS_OF_FIRE_PHOTOS,
    files: [],
};
/*****************
 * THE_JOURNEY_MEDIA
 ****************/
const THE_JOURNEY_LOGO = {
    id: 51,
    name: BOOK_PATHS.THE_JOURNEY,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.THE_JOURNEY, AssetType.LOGO),
    type: AssetType.LOGO
};
const THE_JOURNEY_COVER = {
    id: 52,
    name: BOOK_PATHS.THE_JOURNEY,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.THE_JOURNEY, AssetType.COVER, Extension.JPG),
    type: AssetType.COVER
};
const THE_JOURNEY_PHOTOS = [
         {
            id: 51,
            name: BOOK_PATHS.THE_JOURNEY,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.THE_JOURNEY, AssetType.IMAGE, Extension.JPG, 1),
            type: AssetType.IMAGE
        },
        {
            id: 52,
            name: BOOK_PATHS.THE_JOURNEY,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.THE_JOURNEY, AssetType.IMAGE, Extension.JPG, 2),
            type: AssetType.IMAGE
        },
        {
            id: 53,
            name: BOOK_PATHS.THE_JOURNEY,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.THE_JOURNEY, AssetType.IMAGE, Extension.JPG, 3),
            type: AssetType.IMAGE
        },
];
export const THE_JOURNEY_MEDIA_EN: Media = {
    logo: THE_JOURNEY_LOGO,
    cover: THE_JOURNEY_COVER,
    videos: [],
    photos: THE_JOURNEY_PHOTOS,
    files: [],
};
export const THE_JOURNEY_MEDIA_AR: Media = {
    logo: THE_JOURNEY_LOGO,
    cover: THE_JOURNEY_COVER,
    videos: [],
    photos: THE_JOURNEY_PHOTOS,
    files: [],
};
/*****************
 * PROPHECY_MEDIA
 ****************/
const PROPHECY_LOGO = {
    id: 71,
    name: BOOK_PATHS.PROPHECY,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.PROPHECY, AssetType.LOGO),
    type: AssetType.LOGO
};
const PROPHECY_COVER = {
    id: 72,
    name: BOOK_PATHS.PROPHECY,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.PROPHECY, AssetType.COVER, Extension.JPG),
    type: AssetType.COVER
};
const PROPHECY_PHOTOS = [
        {
        id: 71,
        name: BOOK_PATHS.PROPHECY,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.PROPHECY, AssetType.IMAGE, Extension.JPG, 1),
        type: AssetType.IMAGE
    },
    {
        id: 72,
        name: BOOK_PATHS.PROPHECY,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.PROPHECY, AssetType.IMAGE, Extension.JPG, 2),
        type: AssetType.IMAGE
    },
    {
        id: 73,
        name: BOOK_PATHS.PROPHECY,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.PROPHECY, AssetType.IMAGE, Extension.JPG, 3),
        type: AssetType.IMAGE
    },
];
export const PROPHECY_MEDIA_EN: Media = {
    logo: PROPHECY_LOGO,
    cover: PROPHECY_COVER,
    videos: [],
    photos: PROPHECY_PHOTOS,
    files: [],
};
export const PROPHECY_MEDIA_AR: Media = {
   logo: PROPHECY_LOGO,
    cover: PROPHECY_COVER,
    videos: [],
    photos: PROPHECY_PHOTOS,
    files: [],
};
/*****************
 * POSSESSING_THE_GATES_OF_THE_ENEMY_MEDIA
 ****************/
const POSSESSING_THE_GATES_OF_THE_ENEMY_LOGO = {
    id: 91,
    name: BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY, AssetType.LOGO),
    type: AssetType.LOGO
};
const POSSESSING_THE_GATES_OF_THE_ENEMY_COVER = {
    id: 92,
    name: BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY,
    url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY, AssetType.COVER, Extension.JPG),
    type: AssetType.COVER
};
const POSSESSING_THE_GATES_OF_THE_ENEMY_PHOTOS = [
     {
            id: 91,
            name: BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY,
            url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY, AssetType.IMAGE, Extension.JPG, 1),
            type: AssetType.IMAGE
    },
    {
        id: 92,
        name: BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY, AssetType.IMAGE, Extension.JPG, 2),
        type: AssetType.IMAGE
    },
    {
        id: 93,
        name: BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY,
        url: mediaService.getMediaUrl(EntityType.BOOK, BOOK_PATHS.POSSESSING_THE_GATES_OF_THE_ENEMY, AssetType.IMAGE, Extension.JPG, 3),
        type: AssetType.IMAGE
    },
];
export const POSSESSING_THE_GATES_OF_THE_ENEMY_MEDIA_EN: Media = {
    logo: POSSESSING_THE_GATES_OF_THE_ENEMY_LOGO,
    cover: POSSESSING_THE_GATES_OF_THE_ENEMY_COVER,
    videos: [],
    photos: POSSESSING_THE_GATES_OF_THE_ENEMY_PHOTOS,
    files: [],
};
export const POSSESSING_THE_GATES_OF_THE_ENEMY_MEDIA_AR: Media = {
   logo: POSSESSING_THE_GATES_OF_THE_ENEMY_LOGO,
    cover: POSSESSING_THE_GATES_OF_THE_ENEMY_COVER,
    videos: [],
    photos: POSSESSING_THE_GATES_OF_THE_ENEMY_PHOTOS,
    files: [],
};